
  <div class="container-fluid min-vh-100">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <p class="fw-bold mb-1 text-x">Asset Registry</p>
        <p class="text-muted mb-0 text-xs">
          Comprehensive view of all assets and their valuations
        </p>
      </div>

      <button
        class="btn btn-primary-dark btn-sm text-xxs d-flex align-items-center gap-2"
        @click="open_add_asset_modal"
        data-bs-toggle="modal" 
        data-bs-target="#add_asset_modal"
      >
        Add Asset
      </button>
    </div>

    <div class="row g-3 mb-4 p-2">
      <div class="col-md-4">
        <div class="card shadow rounded-lg p-3 h-100">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <p class="text-muted text-xs mb-1">Total Portfolio Assets</p>
              <p class="fw-bold text-x mb-0">{{ total_assets }}</p>
            </div>
            <i class="bi bi-box-seam fs-2 text-secondary"></i>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card shadow rounded-lg p-3 h-100">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <p class="text-muted text-xs mb-1">Total Active Assets</p>
              <p class="fw-bold text-x mb-0">{{ active_assets }}</p>
            </div>
            <i class="bi bi-check-circle fs-2 text-success"></i>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card shadow rounded-lg p-3 h-100">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <p class="text-muted text-xs mb-1">Total Portfolio Value</p>
              <p class="fw-bold text-x mb-0">
                {{ formatted_portfolio_value }}
              </p>
            </div>
            <i class="bi bi-currency-dollar fs-2 text-primary"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm rounded-4 p-4">
      <div class="mb-3">
        <p class="fw-bold mb-0 text-x">Asset Registry</p>
        <p class="text-muted mb-0 text-xs">
          Showing {{ assets.length }} assets
        </p>
      </div>

      <div class="table-responsive text-xs">
        <table class="table table-hover">
          <thead class="custom-header">
            <tr>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Asset</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Category</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="asset in assets" :key="asset.id">
              <td class="text-xxs text-start">
                <div class="fw-semibold">
                  {{ asset.name || asset.entity_name }}
                </div>
              </td>
              <td clss="text-xxs text-start">
                <span class="status-badge bg-secondary bg-opacity-10 text-white">
                  {{ asset.entity_type_name || 'Asset' }}
                </span>
              </td>

              <td class="text-xxs text-start">
                <span
                  class="status-badge"
                  :class="get_status_class(asset)"
                >
                  {{ get_asset_status(asset) }}
                </span>
              </td>

              <td class="text-xxs text-start">
                <button class="disabled btn btn-primary-dark btn-sm text-xxs" @click="view_asset(asset)">
                  View
                </button>
              </td>
            </tr>

            <tr v-if="!assets.length">
              <td colspan="4" class="text-center text-muted py-4">
                No assets found
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="modal fade"
      id="add_asset_modal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xxs">
              Add Asset
            </p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body p-3">
            <div v-if="validation_error" class="alert alert-danger text-xxs p-2 mb-3">
              {{ validation_error }}
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="assign_sub_entity_type" class="modal-form-label form-label text-xxs">Asset Type *</label>
              <select id="assign_sub_entity_type"
                class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x"
                v-model="assign_sub_entity_type_id" 
                @change="assign_on_sub_entity_change"
                :disabled="filtered_asset_options.length === 0 || is_loading">
                <option value="" disabled selected>Select asset type</option>
                <option v-for="opt in filtered_asset_options" :key="opt.id" :value="opt.id">
                  {{ opt.name }}
                </option>
              </select>
              <div v-if="is_loading" class="text-info text-xxs mt-1">
                <i class="fas fa-spinner fa-spin me-1"></i> Loading asset types...
              </div>
              <div v-if="filtered_asset_options.length === 0 && !is_loading" class="text-danger text-xxs mt-1">
                No asset types available. Make sure you have entity types with "Asset" in their name.
              </div>
              <div v-if="assign_sub_entity_options.length > 0 && filtered_asset_options.length === 0 && !is_loading" class="text-warning text-xxs mt-1">
                Found {{ assign_sub_entity_options.length }} entity types, but none contain "asset" in their name.
              </div>
            </div>

            <div class="modal-form-group form-group mb-3" v-if="assign_form_list.length > 0">
              <label for="assign_form_select" class="modal-form-label form-label text-xxs">Form *</label>
              <select id="assign_form_select"
                class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x"
                v-model="assign_selected_form_id" 
                :disabled="assign_form_list.length === 0 || is_loading">
                <option value="" disabled selected>Select form</option>
                <option v-for="form in assign_form_list" :key="form.id" :value="form.id">
                  {{ form.form_name || form.name }}
                </option>
              </select>
            </div>
            <div class="modal-form-group form-group mb-3" v-else-if="assign_sub_entity_type_id">
              <label class="modal-form-label form-label text-xxs">Form</label>
              <div class="alert alert-info text-xxs p-2">
                <i class="fas fa-spinner fa-spin me-1" v-if="is_loading"></i>
                {{ is_loading ? 'Loading forms...' : 'Select an asset type to see available forms' }}
              </div>
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="assign_entity_name" class="modal-form-label form-label text-xxs">Asset Name *</label>
              <input id="assign_entity_name" type="text" v-model="assign_entity_name"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                placeholder="Enter Asset Name" 
                :disabled="is_loading || is_saving">
            </div>

            <div class="modal-footer border-0 p-2 d-flex justify-content-between">
              <button
                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                @click="save_asset"
                :disabled="is_saving || !is_valid_form"
              >
                <span v-if="is_saving">
                  <span class="spinner-border spinner-border-sm me-1"></span>
                  Saving...
                </span>
                <span v-else>Save Asset</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
